import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-referee-view-detail',
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule],
  templateUrl: './referee-view-detail.component.html',
  styleUrl: './referee-view-detail.component.scss'
})
export class RefereeViewDetailComponent {
  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    public dialogRef: MatDialogRef<RefereeViewDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) { }
}
